import { render, staticRenderFns } from "./ReporteMovimientos.vue?vue&type=template&id=044849fb"
import script from "./ReporteMovimientos.vue?vue&type=script&lang=js"
export * from "./ReporteMovimientos.vue?vue&type=script&lang=js"
import style0 from "./ReporteMovimientos.vue?vue&type=style&index=0&id=044849fb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports